import React from 'react';
import {
  createPlugin,
  createRoutableExtension,
} from '@backstage/core-plugin-api';

import { apisRouteRef, exploreRouteRef, homeRouteRef, adminRouteRef, adminCatalogRouteRef, contributeRouteRef } from './routes';
import { createFrontendPlugin, PageBlueprint } from '@backstage/frontend-plugin-api';

const explorePage = PageBlueprint.make({
  name: 'explore',
  params: {
    routeRef: exploreRouteRef,
    path: '/explore',
    loader: () => import('./components/ExplorePage').then(m => <m.ExplorePage />)
  },
});

const apisPage = PageBlueprint.make({
  name: 'apis',
  params: {
    routeRef: apisRouteRef,
    path: '/apis',
    loader: () => import('./components/ApiPage').then(m => <m.ApiPage />)
  },
});

const adminPage = PageBlueprint.make({
  name: 'admin',
  params: {
    routeRef: adminRouteRef,
    path: '/admin',
    loader: () => import('./components/Admin').then(m => <m.AdminPage />)
  },
});

const adminCatalogPage = PageBlueprint.make({
  name: 'admin-catalog',
  params: {
    routeRef: adminCatalogRouteRef,
    path: '/admin/catalog',
    loader: () => import('./components/Admin').then(m => <m.AdminCatalogPage />)
  },
});

const contributePage = PageBlueprint.make({
  name: 'contribute',
  params: {
    routeRef: contributeRouteRef,
    path: '/contribute',
    loader: () => import('./components/Contribute').then(m => <m.ContributePage />)
  },
});


export const eaPackFrontendPlugin = createFrontendPlugin({
  pluginId: 'ea-pack',
  extensions: [ explorePage, apisPage, adminPage, adminCatalogPage, contributePage ],
  routes: {
    home: homeRouteRef,
    explore: exploreRouteRef,
    apis: apisRouteRef,
    admin: adminRouteRef,
    adminCatalog: adminCatalogRouteRef,
    contribute: contributeRouteRef,
  },


});
